const CreatorMenuIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={22}
    viewBox="0 0 28 22"
    fill="none"
    {...props}
  >
    <path
      d="M23.8 12.3816C23.0268 12.3816 22.4 11.763 22.4 11C22.4 10.237 23.0268 9.61843 23.8 9.61843H26.6C27.3732 9.61843 28 10.237 28 11C28 11.763 27.3732 12.3816 26.6 12.3816H23.8ZM24.92 20.9473C24.4561 21.5577 23.5786 21.6814 22.96 21.2236L20.72 19.5657C20.1014 19.1079 19.9761 18.2419 20.44 17.6315C20.9039 17.0211 21.7814 16.8974 22.4 17.3552L24.64 19.0131C25.2586 19.4709 25.3839 20.3369 24.92 20.9473ZM22.4 4.64479C21.7814 5.1026 20.9039 4.97889 20.44 4.36847C19.9761 3.75806 20.1014 2.89209 20.72 2.43428L22.96 0.776394C23.5786 0.318583 24.4561 0.442294 24.92 1.05271C25.3839 1.66312 25.2586 2.52909 24.64 2.9869L22.4 4.64479ZM5.6 20.671C4.8268 20.671 4.2 20.0524 4.2 19.2894V16.5263C4.2 15.7633 3.5732 15.1447 2.8 15.1447C2.03 15.1447 1.37083 14.8741 0.8225 14.333C0.274167 13.7919 0 13.1414 0 12.3816V9.61843C0 8.85857 0.274167 8.20808 0.8225 7.66697C1.37083 7.12585 2.03 6.8553 2.8 6.8553H7.29333C8.01748 6.8553 8.72801 6.66108 9.34896 6.29342C12.012 4.71663 15.4 6.60962 15.4 9.67435V12.3256C15.4 15.3904 12.012 17.2834 9.34896 15.7066L8.66039 15.2989C8.49 15.198 8.29504 15.1447 8.09633 15.1447C7.49084 15.1447 7 15.6291 7 16.2266V19.2894C7 20.0524 6.3732 20.671 5.6 20.671ZM9.63513 12.6532C10.9388 13.4146 12.6 12.495 12.6 11C12.6 9.50505 10.9388 8.58536 9.63513 9.34677C9.33199 9.52382 8.98415 9.61843 8.63189 9.61843H4.2C3.4268 9.61843 2.8 10.237 2.8 11C2.8 11.763 3.4268 12.3816 4.2 12.3816H8.63189C8.98415 12.3816 9.33199 12.4762 9.63513 12.6532ZM18.3225 13.6077C17.8931 14.4938 16.8 14.0756 16.8 13.0934V8.90661C16.8 7.92441 17.8931 7.50621 18.3225 8.39229C18.7075 9.18669 18.9 10.0559 18.9 11C18.9 11.9441 18.7075 12.8133 18.3225 13.6077Z"
      fill="url(#paint0_linear_1423_15330)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1423_15330"
        x1={0.141094}
        y1={6.85468}
        x2={28.5207}
        y2={11.0099}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0CAECF" />
        <stop offset={1} stopColor="#580F6B" />
      </linearGradient>
    </defs>
  </svg>
);


export default CreatorMenuIcon;
